import { H3 } from "@sellar-io/components";
import dayjs from "dayjs";
import { capitalize, formatCurrency, pluralize } from "@sellar-io/common";
import { useSupplierRelationshipAnalytics } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipAnalytics";
import { StatCard } from "../../../components/card/StatCard";

export const BusinessConnectionAnalytics = ({
  connectionId,
}: {
  connectionId: number;
}) => {
  const { data, isLoading } = useSupplierRelationshipAnalytics(connectionId);

  if (isLoading)
    return (
      <div className="h-[206px] w-full animate-pulse rounded-lg bg-zinc-100"></div>
    );

  if (!data) return;

  const averageOrderRate = data.averageOrderRate?.toFixed(2) ?? "--";
  const averageOrderValue = data.averageOrderValue
    ? formatCurrency(data.averageOrderValue)
    : "--";
  const averageOrderValueSubtitle = data.averageOrderValue
    ? `Total: ${data.totalOrderCount} ${pluralize("order", data.totalOrderCount ?? 1)}`
    : "Yet to order";
  const lifetimeValue = data.lifetimeValue
    ? formatCurrency(data.lifetimeValue)
    : "--";
  const lastOrderDays = capitalize(dayjs(data.lastOrderDate).fromNow());
  const lastOrderDaysString = data.lastOrderDate ? lastOrderDays : "--";
  const lastOrderDate = dayjs(data.lastOrderDate).format("DD/MM/YYYY");
  const lastOrderDateString = data.lastOrderDate
    ? `Placed on: ${lastOrderDate}`
    : "Yet to order";

  const firstOrderDate = dayjs(data.firstOrderDate);
  const firstOrderDateString = data.firstOrderDate
    ? `Since: ${firstOrderDate.format("DD/MM/YYYY")}`
    : "Yet to order";

  return (
    <div>
      <H3>Overview</H3>

      <div className="@container mt-6 flex gap-2 overflow-x-scroll">
        <StatCard
          title="Last ordered"
          stat={lastOrderDaysString}
          subtitle={lastOrderDateString}
        />
        <StatCard
          title="Order frequency"
          stat={averageOrderRate}
          subtitle={data.averageOrderRate ? "Per month" : "Yet to order"}
        />
        <StatCard
          title="Average order value"
          stat={averageOrderValue}
          subtitle={averageOrderValueSubtitle}
        />
        <StatCard
          title="Lifetime value"
          stat={lifetimeValue}
          subtitle={firstOrderDateString}
        />
      </div>
      <p className="text-sm text-zinc-500">
        Last updated at 02:00am on{" "}
        {dayjs().subtract(1, "day").format("DD/MM/YYYY")} (updates once per day)
      </p>
    </div>
  );
};
